import axiosInstance from "../../api/axiosInstance";
import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from "../actionTypes";
import { LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAIL } from "../actionTypes";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL } from "../actionTypes";

import {
  FETCH_DEALERS_REQUEST,
  FETCH_DEALERS_SUCCESS,
  FETCH_DEALERS_FAIL,
} from "../actionTypes";
import {
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_RESET,
} from "../actionTypes";
import { fetchDashboardData } from "./dashboardActions";
import {
  FETCH_ADMINDET_REQUEST,
  FETCH_ADMINDET_SUCCESS,
  FETCH_ADMINDET_FAIL,
} from "../actionTypes";
import {
  UPDATE_ADMINDET_REQUEST,
  UPDATE_ADMINDET_SUCCESS,
  UPDATE_ADMINDET_FAIL,
} from "../actionTypes";
import {
  UPDATE_DEALER_STATUS_REQUEST,
  UPDATE_DEALER_STATUS_SUCCESS,
  UPDATE_DEALER_STATUS_FAIL,
} from "../actionTypes";
import {
  SHARE_CREDENTIALS_REQUEST,
  SHARE_CREDENTIALS_SUCCESS,
  SHARE_CREDENTIALS_FAIL,
} from "../actionTypes";
import {
  FETCH_CLIENT_REPORT_REQUEST,
  FETCH_CLIENT_REPORT_SUCCESS,
  FETCH_CLIENT_REPORT_FAILURE,
} from "../actionTypes";
import {
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,
} from "../actionTypes";
import { toast } from "react-toastify";
// at the top of authActions.js
import { dealerAccess } from "./orderActions";
export const registerUser = (userData, token) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const response = await axiosInstance.post(
      "/api/register/",
      userData,
      config
    );

    dispatch({ type: REGISTER_SUCCESS, payload: response.data });

    const successMessage = response.data.message || "Registration successful.";
    toast.success(successMessage);

    return { success: true };
  } catch (error) {
    dispatch({
      type: REGISTER_FAIL,
      payload: error.response ? error.response.data : error.message,
    });

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to Register";

    toast.error(errorMessage);
    return { success: false };
  }
};

// export const loginUser = (loginData) => async (dispatch) => {
//   try {
//     console.log("Login request initiated with:", loginData);
//     dispatch({ type: LOGIN_REQUEST });

//     const response = await axiosInstance.post("/api/login/", loginData);
//     console.log("Login API response:", response.data);

//     const { access_token } = response.data;

//     if (!access_token) {
//       console.error("No access token received in login response");
//       throw new Error("Access token missing");
//     }

//     dispatch({ type: LOGIN_SUCCESS, payload: response.data });

//     console.log("Login successful, dispatching LOGIN_SUCCESS");
//     console.log("User data:", response.data);

//     localStorage.setItem("userInfo", JSON.stringify(response.data));
//     console.log("Saved userInfo to localStorage:", response.data);
//     dispatch(fetchDashboardData(access_token));
//     const successMessage = "Login successful.";
//     toast.success(successMessage);
//     console.log("Login successful, dispatching LOGIN_SUCCESS");

//     return access_token;
//   } catch (error) {
//     const errPayload = error.response ? error.response.data : error.message;
//     console.error("Login failed with error:", errPayload);

//     dispatch({
//       type: LOGIN_FAIL,
//       payload: errPayload,
//     });
//     const errorMessage =
//       error.response?.data?.message ||
//       error.response?.data?.detail ||
//       error.message ||
//       "Failed to Login";
//     toast.error(errorMessage);
//     throw error;
//   }
// };

// Forgot password (two-step flow via same API):
// 1) { mobile }               -> generates OTP
// 2) { mobile, otp, new_password } -> verifies OTP and updates password

export const loginUser = (loginData) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });

    const response = await axiosInstance.post("/api/login/", loginData);
    const { access_token } = response.data;

    if (!access_token) throw new Error("Access token missing");

    dispatch({ type: LOGIN_SUCCESS, payload: response.data });
    localStorage.setItem("userInfo", JSON.stringify(response.data));

    // ✅ Both called together after successful login
    dispatch(fetchDashboardData(access_token));
    dispatch(dealerAccess(access_token)); // ← ADD THIS

    toast.success("Login successful.");
    return access_token;

  } catch (error) {
    const errPayload = error.response ? error.response.data : error.message;
    dispatch({ type: LOGIN_FAIL, payload: errPayload });
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to Login";
    toast.error(errorMessage);
    throw error;
  }
};
export const forgotPassword = (payload) => async (dispatch) => {
  try {
    // Reuse password update action types for loading state if needed
    dispatch({ type: UPDATE_PASSWORD_REQUEST });

    const response = await axiosInstance.post("/api/forgot-password/", payload);

    dispatch({ type: UPDATE_PASSWORD_SUCCESS, payload: response.data });

    const message =
      response.data?.message ||
      (payload.otp ? "Password updated successfully" : "OTP has been sent");
    toast.success(message);

    return { success: true, data: response.data };
  } catch (error) {
    const errPayload = error.response ? error.response.data : error.message;
    dispatch({
      type: UPDATE_PASSWORD_FAIL,
      payload: errPayload,
    });

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to process forgot password request";
    toast.error(errorMessage);

    return { success: false, error: errPayload };
  }
};
export const logoutUser = (token) => async (dispatch) => {
  try {
    dispatch({ type: LOGOUT_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    await axiosInstance.post("/api/logout/", {}, config);

    dispatch({ type: LOGOUT_SUCCESS });

    // Remove from localStorage
    localStorage.removeItem("userInfo");
  } catch (error) {
    dispatch({
      type: LOGOUT_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
  }
};
export const updateUser = (userData, token, userId) => async (dispatch) => {
  console.log(" updateUser received:", { token, userId }); // Add this
  try {
    dispatch({ type: UPDATE_USER_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // Append userId in the URL path
    const response = await axiosInstance.post(
      `/api/edit-profile/${userId}/`,
      userData,
      config
    );

    console.log("Updating user with ID:", userId);

    dispatch({ type: UPDATE_USER_SUCCESS, payload: response.data });

    const successMessage =
      response.data.message || "User updated successfully.";
    toast.success(successMessage);
    dispatch({ type: UPDATE_USER_RESET });
    return { success: true };
  } catch (error) {
    const errPayload = error.response ? error.response.data : error.message;
    console.error("Update failed with error:", errPayload);
    dispatch({
      type: UPDATE_USER_FAIL,
      payload: errPayload,
    });
    if (error.response?.data) {
      console.log("Full API error response:", error.response.data);
    }

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to update user.";
    toast.error(errorMessage);
    return { success: false };
    throw error;
  }
};

export const fetchDealers = (token, params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DEALERS_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params,  // Pass params correctly inside config
    };

    const { data } = await axiosInstance.get("/api/dealer-details/", config);

    dispatch({
      type: FETCH_DEALERS_SUCCESS,
      payload: data.data,
    });
    console.log("data.data", data.data);

    console.log("Request params:;;;", params); // ✅ log params
    // dispatch(fetchDashboardData(data.data));
    return data;
  } catch (error) {
    dispatch({
      type: FETCH_DEALERS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch dealers",
    });
  }
};
export const updateDealerStatus =
  (userId, activate, deactivateCoupons, token) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_DEALER_STATUS_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const body = {
        is_activate: activate,
        is_deactivate: !activate,
        deactivate_coupons: deactivateCoupons,
      };

      const response = await axiosInstance.post(
        `/api/action-dealers/${userId}/`,
        body,
        config
      );

      dispatch({
        type: UPDATE_DEALER_STATUS_SUCCESS,
        payload: response.data,
      });

      toast.success(response.data.message || "Status updated successfully");
    } catch (error) {
      dispatch({
        type: UPDATE_DEALER_STATUS_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to update status",
      });
      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Failed to update status"
      );
    }
  };

export const fetchAdminDetails = (token) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ADMINDET_REQUEST });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axiosInstance.get("/api/admin-details/", config);
    dispatch({
      type: FETCH_ADMINDET_SUCCESS,
      payload: data,
    });
    console.log("data.data", data.data);
    dispatch(fetchDashboardData(data.data));
  } catch (error) {
    dispatch({
      type: FETCH_ADMINDET_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch dealers",
    });
  }
};

export const updateAdminDetails =
  (id, updatedData, token) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_ADMINDET_REQUEST });

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const { data } = await axiosInstance.post(
        `/api/update-admin-details/${id}/`,
        updatedData,
        config
      );

      dispatch({
        type: UPDATE_ADMINDET_SUCCESS,
        payload: data,
      });

      // Optionally refresh the admin details after update
      dispatch(fetchAdminDetails(token));
    } catch (error) {
      dispatch({
        type: UPDATE_ADMINDET_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to update admin details",
      });
    }
  };
export const shareDealerCredentials = (userId, token) => async (dispatch) => {
  try {
    dispatch({ type: SHARE_CREDENTIALS_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axiosInstance.post(
      "/api/share-credentials/",
      { user_id: userId },
      config
    );

    dispatch({ type: SHARE_CREDENTIALS_SUCCESS, payload: response.data });
    const successMessage =
      response.data.message || "User Credentials Sent successfully.";
    toast.success(successMessage);
  } catch (error) {
    dispatch({
      type: SHARE_CREDENTIALS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to update user.";
    toast.error(errorMessage);
    throw error;
  }
};
export const fetchclientReport = (token) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CLIENT_REPORT_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axiosInstance.get(
      "/api/client-wise-report/",
      config
    );

    dispatch({
      type: FETCH_CLIENT_REPORT_SUCCESS,
      payload: data.data,
    });
    console.log("data.data", data.data);
  } catch (error) {
    dispatch({
      type: FETCH_CLIENT_REPORT_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch Client List",
    });
  }
};

export const updatePassword = (passwordData, token) => async (dispatch) => {
  dispatch({ type: UPDATE_PASSWORD_REQUEST });
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axiosInstance.post(
      "/api/update-password/",
      passwordData,
      config
    );

    dispatch({
      type: UPDATE_PASSWORD_SUCCESS,
      payload: data,
    });

    toast.success(data.message || "Password updated successfully");
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to update password";
    
    dispatch({
      type: UPDATE_PASSWORD_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
    return { success: false, error: errorMessage };
  }
};
